/**
 * Product rule: never display specific commission split percentages or
 * compensation figures (CLAUDE.md, Key product rules). Free-text fields that
 * reach an agent-facing surface run through this before they are saved.
 *
 * Deliberately narrow so ordinary copy passes:
 * - a split is two numbers joined by / or - that ADD UP TO 100 ("90/10",
 *   "70-30"), so dates ("Oct 4-5") and counts ("3-5 agents") are not flagged;
 * - any percentage, or the word "split" / "splits";
 * - a dollar figure next to a compensation word ("$500 desk fee", "cap of
 *   $16k"). Sales volume on its own ("$5M+ producers") is a requirement, not
 *   compensation, and passes.
 */
const PAIR = /(?<![\d$.])(\d{1,3})\s*(?:\/|-|–|—)\s*(\d{1,3})(?![\d.%])/g;
const PERCENT = /\d\s*%|\bpercent(?:age)?\b/i;
const SPLIT_WORD = /\bsplits?\b/i;
const COMP_WORD = "(?:cap|caps|capped|fee|fees|desk|commission|royalty|per\\s+(?:deal|transaction|month))";
const MONEY_NEAR_COMP = new RegExp(
  `\\$\\s*\\d[\\d,.]*\\s*[kK]?\\b[^.]{0,30}\\b${COMP_WORD}\\b|\\b${COMP_WORD}\\b[^.]{0,30}\\$\\s*\\d`,
  "i",
);

export const COMPENSATION_GUARD_MESSAGE = "Keep compensation details in the Value tab.";

const hasSplitPair = (text: string): boolean => {
  for (const m of text.matchAll(PAIR)) {
    if (Number(m[1]) + Number(m[2]) === 100) return true;
  }
  return false;
};

/** The inline error for `text`, or null when it is fine to show agents. */
export const compensationGuardError = (text: string | undefined | null): string | null => {
  if (!text) return null;
  if (hasSplitPair(text) || PERCENT.test(text) || SPLIT_WORD.test(text) || MONEY_NEAR_COMP.test(text)) {
    return COMPENSATION_GUARD_MESSAGE;
  }
  return null;
};
